import { ChangeEvent } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { NeuInput, NeuInputProps } from '@hcahealthcaredpx/neutron-react';

import { REQUIRED_SYMBOL } from './constants';

type FormInputProps = Omit<NeuInputProps, 'name'> & {
  name: string;
};

export const FormInput = ({ name, label = '', required, ...rest }: FormInputProps): JSX.Element => {
  const {
    control,
    trigger,
    formState: { errors },
  } = useFormContext();

  const errorMessage = errors?.[name]?.message as string | undefined;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <NeuInput
          label={required ? `${label} ${REQUIRED_SYMBOL}` : label}
          required={required}
          value={field.value}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            field.onChange(e.target.value);
          }}
          onNeuBlur={() => trigger(name)}
          invalid={errorMessage}
          error={!!errorMessage}
          {...rest}
        />
      )}
    />
  );
};
